import { useAccountContext } from '@gonfalon/app-context/useAccountContext';
import { enableContextualFeedbackBot } from '@gonfalon/dogfood-flags/dogfood-flags';
import { isReader as isReaderProfile } from '@gonfalon/members/isReader';
import { Message } from '@gonfalon/messages/Message';
import { Button, type ButtonProps, Tooltip, TooltipTrigger } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

type ContextualFeedbackButtonProps = {
  variant?: 'minimal' | 'default' | 'primary';
  isCompact?: boolean;
  className?: string;
} & ButtonProps;

export function ContextualFeedbackButton({
  className,
  variant,
  isCompact,
  onPress,
  size,
  ...buttonProps
}: ContextualFeedbackButtonProps) {
  const { profile } = useAccountContext();
  const isReader = isReaderProfile(profile);

  if (isReader || !enableContextualFeedbackBot()) {
    return null;
  }

  return (
    <TooltipTrigger>
      <Button className={className} variant={variant} onPress={onPress} size={size} {...buttonProps}>
        {isCompact ? (
          <Icon name="chat-bubble-outline" />
        ) : (
          <>
            <Message id="feedback.contextualTrigger.giveFeedback" />{' '}
          </>
        )}
      </Button>
      {isCompact && (
        <Tooltip>
          <Message id="feedback.contextualTrigger.giveFeedback" />
        </Tooltip>
      )}
    </TooltipTrigger>
  );
}
